<div fxLayout="column" fxLayoutGap="16px">
  <div class="card mat-padding-2">
    <div class="mat-h1">Your profile</div>

    <form
      nz-form
      novalidate
      [formGroup]="form"
      nzLayout="vertical"
      (ngSubmit)="submit()"
    >
      <formly-form
        [model]="model"
        [fields]="fields"
        [options]="options"
        [form]="form"
      ></formly-form>

      <button
        nz-button
        type="submit"
        nzType="primary"
        [disabled]="!form.valid"
        [nzLoading]="loading"
      >
        Save
      </button>
    </form>
  </div>

  @if ((userService.user$ | async)?.contactId; as contactId) {
  <etoh-contact-add
    title="My contact"
    [standalone]="false"
    [id]="contactId"
  ></etoh-contact-add>
  }

  <div class="card mat-padding-2">
    <div class="mat-h1">Extra informations</div>

    @for (info of extraInformations$ | async; track info) {
    <p>{{ info.label }}: {{ info.value }}</p>
    }
  </div>
</div>
